<template>
  <section class="branding-carousel">
    <img
      class="branding-carousel__arrow icon"
      src="../assets/images/left.svg"
      @click="goBack"
    />
    <div
      v-for="(slide, i) in slides"
      :key="`slide_${i}`"
      class="branding-carousel__wrapper"
    >
      <div
        v-if="chosenSlide === i"
        class="branding-carousel__wrapper--slide"
        :style="`background-image: url(${require(`../assets/images/${slide.background}.png`)})`"
      >
        <img
          v-for="(image, i) in slide.images"
          :key="`image_${i}`"
          :src="require(`../assets/images/${image.image}`)"
          :style="`top: ${image.top}%; left: ${image.left}%; width: ${image.width}%`"
        />
      </div>
      <div v-if="chosenSlide === i" class="branding-carousel__wrapper--content">
        <h5>{{ slide.title }}</h5>
        <p>{{ slide.body_1 }}</p>
        <p>{{ slide.body_2 }}</p>
      </div>
    </div>
    <img
      class="branding-carousel__arrow icon"
      src="../assets/images/right.svg"
      @click="goForward"
    />
  </section>
</template>

<script>
export default {
  name: 'BrandingCarousel',
  props: {
    slides: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      chosenSlide: 0,
    }
  },
  methods: {
    goForward() {
      this.chosenSlide !== this.slides.length - 1
        ? (this.chosenSlide += 1)
        : (this.chosenSlide = 0)
    },
    goBack() {
      this.chosenSlide !== 0
        ? (this.chosenSlide -= 1)
        : (this.chosenSlide = this.slides.length - 1)
    },
  },
}
</script>

<style lang="scss">
$desktop: 1450px;
$tablet: 768px;
$mobile: 600px;

.branding-carousel {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  &__arrow {
    width: 50px;
    margin-top: -150px;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
    @media (max-width: $tablet) {
      margin-top: -500px;
    }
  }
  &__wrapper {
    &--slide {
      background-size: cover;
      background-position: center;
      border-radius: 30px;
      height: 600px;
      width: 100%;
      position: relative;
      @media (max-width: $tablet) {
        height: 300px;
      }
      img {
        position: absolute;
        border-radius: 30px;
        border: 2px solid var(--color-white-1);
      }
    }
    &--content {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      margin: 50px 0;
      @media (max-width: $tablet) {
        flex-direction: column;
      }
      h5,
      p {
        padding: 0;
        margin: 0;
        margin-right: 5%;
        @media (max-width: $tablet) {
          margin: 0;
        }
      }
      h5 {
        width: 15%;
        @media (max-width: $tablet) {
          width: 100%;
          margin-bottom: 20px;
        }
      }
      p {
        width: 35%;
        @media (max-width: $tablet) {
          width: 100%;
        }
      }
    }
  }
}
</style>